const MAC_PLATFORM = /mac|iphone|ipad/i;

export function isMacPlatform(): boolean {
	if (typeof navigator === "undefined") {
		return false;
	}
	const { userAgentData } = navigator as Navigator & { userAgentData?: { platform?: string } };
	return MAC_PLATFORM.test(userAgentData?.platform || navigator.platform || "");
}
